!function() {
  "use strict";
  customElements.get("sticky-bottom") || customElements.define("sticky-bottom", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.firstElementChild && ([ "load", "resize" ].forEach((listener => window.addEventListener(listener, (() => this.setTop())))), 
      new MutationObserver((mutationsList => {
        for (const mutation of mutationsList) "childList" === mutation.type && mutation.addedNodes.length > 0 && this.setTop();
      })).observe(this, {
        childList: !0,
        subtree: !0
      }));
    }
    setTop() {
      const stickyAddToCart = document.querySelector("[data-atc]")?.clientHeight || 0;
      this.offsetHeight > window.innerHeight && (this.style.top = -(this.offsetHeight - window.innerHeight) - stickyAddToCart + "px");
    }
  });
}();